import { lang } from '@public/utils/filters'
export default {
  serviceProviderManagementTypeList: [
    { value: 1, label: lang('外包'), name: lang('外包') },
    { value: 2, label: lang('自营'), name: lang('自营') }
  ],
  serviceProviderManagementRoleList: [
    { value: '1', label: lang('IM客服'), name: lang('IM客服') },
    { value: '2', label: lang('400电话'), name: lang('400电话') }
  ],
  // 渠道
  channelList: [
    { value: 'PDD', label: lang('PDD'), name: lang('PDD') },
    { value: 'MP', label: lang('MP'), name: lang('MP') },
    { value: 'WEB', label: lang('WEB'), name: lang('WEB') }
  ],
    // 服务评价报表渠道
  channelCode: [
      { value: 1, label: lang('总数'), name: lang('总数') },
      { value: 2, label: lang('WEB'), name: lang('WEB') },
      { value: 3, label: lang('MP'), name: lang('MP') },
      { value: 4, label: lang('PDD'), name: lang('PDD') }
    ],
  // 工单紧急程度
  workOrderEmergencyLevel: [
    { value: 1, label: lang('紧急'), name: '紧急' },
    { value: 2, label: lang('一般'), name: '一般' }
  ],
  // 工单是否升级
  workOrderUpgradeStatus: [
    { value: 1, label: lang('是'), name: '是' },
    { value: 2, label: lang('否'), name: '否' }
  ],// 工单审核状态
  workOrderClaimReview: [
    { value: 1, label: lang('审核中'), name: '审核中' },
    { value: 2, label: lang('审核驳回'), name: '审核驳回' },
    { value: 3, label: lang('审核通过'), name: '审核通过' }
  ],
  // 工单来源
  workOrderSource: [
    { value: 1, label: lang('网点组'), name: '网点组' },
    { value: 2, label: lang('代理组'), name: '代理组' },
    { value: 3, label: lang('总部组'), name: '总部组' },
    { value: 4, label: lang('电话组别'), name: '电话组别' },
    { value: 5, label: lang('总部工单组'), name: '总部工单组' }
  ],
  // 处理工单选项
  workOrderHandleType: [
    { value: 4, label: lang('关闭'), name: '关闭' },
    { value: 5, label: lang('继续处理'), name: '继续处理' },
    { value: 6, label: lang('升级'), name: '升级' }
  ],
  // 工单状态
  workOrderStatus: [
    { value: 1, label: lang('待分配'), name: '待分配' },
    { value: 2, label: lang('处理中'), name: '处理中' },
    { value: 3, label: lang('已关闭'), name: '已关闭' }
  ],
  // 工单类型
  workOrderType: [
    { value: 1, label: lang('普通工单'), name: '普通工单' },
    { value: 2, label: lang('理赔工单'), name: '理赔工单' }
  ],
  // 短信模板类型
  messageTemplateType: [
    { value: 1, label: lang('固定模板'), name: lang('固定模板') },
    { value: 2, label: lang('自定义模板'), name: lang('自定义模板') }
  ],
  // 录入组别
  workOrderRecordGroup: [
    { value: 1, label: lang('电话组'), name: lang('电话组') },
    { value: 2, label: lang('在线组'), name: lang('在线组') }
  ],
  // 工单紧急程度
  workOrderEmergencyLevel: [
    { value: 1, label: lang('紧急'), name: '紧急' },
    { value: 2, label: lang('一般'), name: '一般' }
  ],
  // 工单是否升级
  workOrderUpgradeStatus: [
    { value: 1, label: lang('是'), name: '是' },
    { value: 2, label: lang('否'), name: '否' }
  ],
  // 催单原因
  urgeReason: [
    { value: 1, label: lang('无人回复'), name: '无人回复' },
    { value: 2, label: lang('虚假回复'), name: '虚假回复' },
    { value: 3, label: lang('回复结果不满意'), name: '回复结果不满意' }
  ],
    // 转单责任方
  visitorStatus: [
    { value: 1, label: lang('寄件人'), name: '寄件人' },
    { value: 2, label: lang('收件人'), name: '收件人' },
    { value: 3, label: lang('其他'), name: '其他' },
  ],
    // IM数据报表
  imReportForm: [
    { value: 'PERSONAL', label: lang('个人'), name: lang('个人') },
    { value: 'MANAGER', label: lang('管理者'), name: lang('管理者') }

  ],
    // 在线FCR 次数
  onlineFcr72HCount: [
    { value: 1, label: lang('1次'), name: lang('1次') },
    { value: 2, label: lang('2次'), name: lang('2次') },
    { value: 3, label: lang('3次'), name: lang('3次') },
    { value: 4, label: lang('4次'), name: lang('4次') },
    { value: 5, label: lang('5次'), name: lang('5次') },
    { value: 6, label: lang('6次及以上'), name: lang('6次及以上') },
  ]
}
